import { getSkillConfig, type SkillConfig } from '../../srs/scheduler';

// 依据本地覆盖度对写作 SRS 做轻量调节：高覆盖→更长间隔、略增 ease；低覆盖→收紧间隔、降低 ease。
export function deriveWritingSrsAdjustments(coverage: number): Partial<SkillConfig> {
  const base = getSkillConfig('writing');
  const capped = Math.max(0, Math.min(coverage, 100));

  // 分段系数，保持温和，避免骤变
  const boost =
    capped >= 85 ? 0.15 : capped >= 70 ? 0.05 : capped >= 50 ? -0.05 : capped >= 30 ? -0.12 : -0.18;
  const easeDelta = capped >= 85 ? 0.02 : capped >= 70 ? 0.01 : capped >= 50 ? -0.02 : -0.03;
  const hardDelta = capped < 60 ? -0.015 : 0;

  const intervalGood = Math.max(0.5, base.intervalAdjust.good * (1 + boost));
  const intervalHard = Math.max(0.25, base.intervalAdjust.hard * (1 + boost / 2));

  return {
    intervalAdjust: { ...base.intervalAdjust, good: intervalGood, hard: intervalHard },
    easeAdjust: {
      ...base.easeAdjust,
      good: base.easeAdjust.good + easeDelta,
      hard: base.easeAdjust.hard + hardDelta,
    },
  };
}

